<template>
  <div class="viewport viewport-compact viewport-with-top-nav">
    <TopNav></TopNav>
    <div class="display-1 my-3">{{ $t('QrScanPage.title') }}</div>

    <i18n path="QrScanPage.description" tag="label" for="QrScanPage.palPartnersLink"
          id="qr">
      <template v-slot:action>
        <router-link id="pal-partners-link" :to="{ name: 'pal-partners' }">
          {{ $t('QrScanPage.palPartnersLink') }}
        </router-link>
      </template>
    </i18n>

    <Alert v-if="scannedUnsupportedText" type="danger" class="my-3">{{ $t('QrScanPage.unsupportedQrCode') }}</Alert>
    <div class="overflow-hidden card-rounded mb-5 position-relative">
      <div v-if="cameraNotPermittedHint"
           class="d-flex flex-column align-items-center justify-content-center pt-4 text-danger">
        <div class="text-center">
          <Icon icon-name="alert-circle-outline" icon-class="icon-xxl ms-n1"></Icon>
        </div>
        <div>
          {{ $t('QrScanPage.cameraPermissionNotGranted') }}
        </div>
      </div>

      <QrcodeStream v-if="showQr" @decode="onDecode" :track="paintBoundingBox"></QrcodeStream>

      <div v-if="scanningSucceeded"
           id="qr-scan-success-message"
           class="bg-success d-flex flex-column align-items-center justify-content-center text-white">
        <div class="text-center">
          <Icon icon-name="checkmark-circle-2" icon-class="icon-xxl ms-n1"></Icon>
        </div>
        <div>
          {{ $t('QrScanPage.loading') }}
        </div>
      </div>
      <div v-if="showRefreshButton"
           class="d-flex flex-column align-items-center justify-content-center cursor"
           @click.prevent="refreshPage"
      >
        <div class="text-center">
          <Icon icon-name="refresh" icon-class="icon-lg ms-n1"></Icon>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between mb-3 gap-2">
      <div class="text-muted small">
        {{ $t('QrScanPage.instruction') }}
      </div>
    </div>

    <div class="flex-grow-1"></div>
  </div>
</template>
<script>

import Alert from '@shared/components/Alert'
import Icon from '@shared/components/Icon'
import TopNav from '@shared/components/TopNav'
import settings from '@shared/settings'

export default {
  name: 'QrScanPage',
  components: {
    Alert,
    Icon,
    TopNav,
    QrcodeStream: async () => (await import(/* webpackChunkName: "qr-code-reader" */ 'vue-qrcode-reader')).QrcodeStream
  },
  data () {
    return {
      showQr: false,
      cameraNotPermittedHint: false,
      scanningSucceeded: false,
      scannedUnsupportedText: false,
      showRefreshButton: false
    }
  },
  async mounted() {
    if (settings.isAndroid() && window.cameraPermission) {
      window.cameraPermission.requestCameraPermission()
    } else {
      this.showQr = true
    }
  },
  created() {
    this.$root.$on('camera-permission-rejected', this.onCameraPermissionRejected)
    this.$root.$on('camera-permission-granted', this.onCameraPermissionGranted)
  },
  destroyed() {
    this.$root.$off('camera-permission-rejected', this.onCameraPermissionRejected)
    this.$root.$off('camera-permission-granted', this.onCameraPermissionGranted)
  },
  methods: {
    onCameraPermissionGranted() {
      this.showQr = true
      this.cameraNotPermittedHint = false
    },
    onCameraPermissionRejected() {
      this.cameraNotPermittedHint = true
      this.showQr = false
    },
    showScanSuccessAndGracefullyRedirect(url) {
      setTimeout(() => {
        window.location.href = url
        this.showRefreshButton = true
        this.showQr = false
        this.scanningSucceeded = false
      }, 1500)
    },
    onDecode(decodedText) {
      this.scannedUnsupportedText = false
      if (decodedText.startsWith(window.location.origin) || decodedText.startsWith(process.env.VUE_APP_QR_CODE_SERVICE_BASE_URL)) {
        this.scanningSucceeded = true
        this.showScanSuccessAndGracefullyRedirect(decodedText)
      } else {
        this.scannedUnsupportedText = true
      }
    },
    paintBoundingBox(detectedCodes, ctx) {
      for (const detectedCode of detectedCodes) {
        const { boundingBox: { x, y, width, height } } = detectedCode

        ctx.lineWidth = 3
        ctx.strokeStyle = '#d8252c'
        ctx.strokeRect(x, y, width, height)
      }
    },
    refreshPage() {
      this.$router.go(0)
    }
  }
}
</script>

<style lang="scss" scoped>
  #qr-scan-success-message {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    opacity: 0.75;
  }
  .cursor {
    cursor: pointer;
  }
</style>
